import Vue from "vue";
import Router from "vue-router";
import store from "../src/store";
import AuthLayout from "./layout/AuthLayout.vue";
import Auth from "./views/Auth.vue";
import Camera from "./views/Camera.vue";
import Departments from "./views/Departments.vue";
import FacialRecognition from "./views/FacialRecognition.vue";
import CompanySelect from "./views/CompanySelect.vue";
import QrCode from "./views/QrCode.vue";
import Sync from "./views/Sync.vue";
import HomeMenu from "./views/HomeMenu.vue";

// Lazy loading components
const Iden = (resolve) => {
  require.ensure(
    ["./views/Identification.vue"],
    () => {
      resolve(require("./views/Identification.vue"));
    },
    "iden"
  );
};

const Path = (resolve) => {
  require.ensure(
    ["./components/Path.vue"],
    () => {
      resolve(require("./components/Path.vue"));
    },
    "path"
  );
};

const Scheduled = (resolve) => {
  require.ensure(
    ["./components/Scheduled.vue"],
    () => {
      resolve(require("./components/Scheduled.vue"));
    },
    "scheduled"
  );
};

// const NonScheduled = resolve => {
//   require.ensure(
//     ["./components/NonScheduled.vue"],
//     () => {
//       resolve(require("./components/NonScheduled.vue"));
//     },
//     "nonScheduled"
//   );
// };

const NewGuest = (resolve) => {
  require.ensure(
    ["./components/NewGuest.vue"],
    () => {
      resolve(require("./components/NewGuest.vue"));
    },
    "newguest"
  );
};

const Success = (resolve) => {
  require.ensure(
    ["./components/Success.vue"],
    () => {
      resolve(require("./components/Success.vue"));
    },
    "success"
  );
};

Vue.use(Router);

const router = new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "initial",
      component: AuthLayout,
      redirect: "/auth",
      meta: {
        auth: false,
      },
      children: [
        {
          name: "sync",
          component: Sync,
          path: "/auth",
        },
        {
          name: "home",
          component: HomeMenu,
          path: "/home",
        },
        {
          path: "/home/visitors",
          name: "visitors",
          component: HomeMenu,
        },
      ],
    },
    {
      path: "/home/employees",
      name: "employees",
      component: CompanySelect,
    },
    {
      path: "/home/visitors/non-scheduled",
      name: "non-scheduled",
      component: CompanySelect,
    },
    {
      path: "/home/visitors/departments/:companyId",
      name: "departments",
      component: Departments,
    },
    {
      path: "/home/visitors/qr-code",
      name: "qr-code",
      component: QrCode,
    },
    {
      path: "/home/visitors/non-scheduled/facial-recognition",
      name: "facial-recognition",
      component: FacialRecognition,
    },
    {
      path: "/home/visitors/non-scheduled/camera/:id",
      name: "camera",
      component: Camera,
    },
    {
      path: "*",
      redirect: "/",
    },
  ],
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = store.state.auth;

  if (isAuthenticated === false && to.path !== "/" && to.path !== "/auth") {
    return next("/auth");
  }else{
    next();
  }
});



export default router;
